import { render, staticRenderFns } from "./ServicosTabela.vue?vue&type=template&id=26cdb736&scoped=true"
import script from "./ServicosTabela.vue?vue&type=script&lang=js"
export * from "./ServicosTabela.vue?vue&type=script&lang=js"
import style0 from "./ServicosTabela.vue?vue&type=style&index=0&id=26cdb736&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cdb736",
  null
  
)

export default component.exports